var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "title-wrapper" }, [_vm._v(" 转账 ")]),
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            { attrs: { label: "选择联系人" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择收款账户地址" },
                  on: { change: _vm.formatAccount },
                  model: {
                    value: _vm.account,
                    callback: function ($$v) {
                      _vm.account = $$v
                    },
                    expression: "account",
                  },
                },
                _vm._l(_vm.accountList, function (item, index) {
                  return _c("el-option", { key: index, attrs: { value: item } })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "选择支付方式" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择支付方式" },
                  on: {
                    change: function ($event) {
                      _vm.transfer.tradType = _vm.searchOption(
                        _vm.tradTypeList,
                        _vm.tradType
                      )
                    },
                  },
                  model: {
                    value: _vm.tradType,
                    callback: function ($$v) {
                      _vm.tradType = $$v
                    },
                    expression: "tradType",
                  },
                },
                _vm._l(_vm.tradTypeList, function (item, index) {
                  return _c("el-option", { key: index, attrs: { value: item } })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "转账货币" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择转账货币" },
                  on: {
                    change: function ($event) {
                      _vm.transfer.CurrencyType = _vm.searchOption(
                        _vm.currencyList,
                        _vm.currency
                      )
                    },
                  },
                  model: {
                    value: _vm.currency,
                    callback: function ($$v) {
                      _vm.currency = $$v
                    },
                    expression: "currency",
                  },
                },
                _vm._l(_vm.currencyList, function (item, index) {
                  return _c("el-option", { key: index, attrs: { value: item } })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "转账通道" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择转账通道" },
                  on: {
                    change: function ($event) {
                      _vm.transfer.ChannelId = _vm.searchOption(
                        _vm.channelIdList,
                        _vm.channelId
                      )
                    },
                  },
                  model: {
                    value: _vm.channelId,
                    callback: function ($$v) {
                      _vm.channelId = $$v
                    },
                    expression: "channelId",
                  },
                },
                _vm._l(_vm.channelIdList, function (item, index) {
                  return _c("el-option", { key: index, attrs: { value: item } })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "转账金额" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.transfer.Amount,
                  callback: function ($$v) {
                    _vm.$set(_vm.transfer, "Amount", _vm._n($$v))
                  },
                  expression: "transfer.Amount",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入转账备注" },
                model: {
                  value: _vm.transfer.Remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.transfer, "Remark", $$v)
                  },
                  expression: "transfer.Remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$router.back()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitTransfer },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }